import React, { useEffect } from "react";
import "./FooterPages.css";
import { Link } from "react-router-dom";
import ProductCard from "../page/Home/productsNewDesign/ProductCards";
import { fetchTestimonialDetails } from "../redux/features/footerPages/footerPagesContentSlice";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

const HappyCustomers = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const lang = useSelector((state) => state.language.lang);

  const { testimonialContent, status, error } = useSelector(
    (state) => state.footerPagesContent
  );

  useEffect(() => {
    const api_token = localStorage.getItem("api_token");
    dispatch(fetchTestimonialDetails({ api_token, lang }));
  }, [dispatch, lang]);

  return (
    <div className="happy-customers">
      {/* Hero Section */}
      <div className="container-fluid faq-heading">
        <div className="row">
          <h1 className="text-center">{`${t("Our_Happy_Customers")}`}</h1>
          <p className="lead text-center">{`${t("Hear_what_our")}`}</p>
        </div>
      </div>

      <section className="testimonials-section py-5">
        <div className="container">
          <h2 className="text-center mb-5">{`${t(
            "Customer_Testimonials"
          )}`}</h2>
          <div className="row">
            {status === "loading" && <p>Loading testimonials...</p>}
            {status === "failed" && <p className="text-danger">{error}</p>}

            {testimonialContent?.length > 0
              ? testimonialContent.map((testimonial, index) => (
                  <div className="col-md-4 d-flex mb-4" key={testimonial.id}>
                    <div className="card mb-4 shadow-lg border-0 rounded-3 hover-effect w-100">
                      <div className="card-body d-flex flex-column">
                        <div className="d-flex align-items-center mb-4">
                          {/* User Image */}
                          <img
                            src={
                              testimonial.image
                                ? testimonial.image
                                : `https://i.pravatar.cc/150?u=${testimonial.id}`
                            }
                            alt="No Image"
                            className="rounded-circle me-3"
                            style={{ width: "60px", height: "60px" }}
                            onError={(e) => {
                              e.target.onerror = null; // prevents infinite loop
                              e.target.src =
                                "https://amzio.de/api/uploads/products/no-thumbnail.png";
                            }}
                          />
                          <div>
                            <h5 className="card-title mb-1 fw-bold">
                              {testimonial.name}
                            </h5>
                            <h6 className="card-subtitle mb-2 text-muted">
                              {testimonial.country}
                            </h6>
                          </div>
                        </div>

                        {/* Rating */}
                        <div className="mb-3 text-warning">
                          {[...Array(5)].map((_, i) => (
                            <span
                              key={i}
                              className={
                                i < testimonial.rating ? "" : "text-muted"
                              }
                            >
                              ★
                            </span>
                          ))}
                        </div>

                        <p className="card-text fst-italic mb-3">
                          "{testimonial.message}"
                        </p>
                      </div>
                    </div>
                  </div>
                ))
              : status !== "loading" && <p>No testimonials available</p>}
          </div>
        </div>
      </section>

      {/* Featured Products Section */}
      <ProductCard />

      {/* Call-to-Action Section */}
      <section className="cta-section text-center py-5">
        <h2>{`${t("Share_Your_Feedback")}`}</h2>
        <p>{`${t("Your_feedback_helps")}`}</p>
        <Link to="/contact-us">
          <button className="btn btn-primary btn-lg mt-2">{`${t(
            "Submit_a_Review"
          )}`}</button>
        </Link>
      </section>
    </div>
  );
};

export default HappyCustomers;
